export const checkRwcInterval = 100;
